module.exports = __webpack_public_path__ + "img/square-up-right.38b48333.svg";